function DonationProgress({ totalLimit = 500, donationDone = 0 }) { 
    const progressPercentage = (donationDone / totalLimit) * 100;
    return (
        <div className="col-md-6">
            <div className="alert alert-danger h-100" role="alert">
                <h3 className="mb-4">Total Blood Donation</h3>
                <p className="mb-0">Donors are allowed to donate up to {totalLimit} mL every 8 weeks.</p>
                <p>Donating blood outside of this program makes donor ineligible.</p>
                <div className="progress my-3">
                    <div
                        className="progress-bar bg-danger"
                        role="progressbar"
                        style={{ width: `${progressPercentage}%` }}
                        aria-valuenow={progressPercentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>
                <h4>
                    <b>{donationDone} mL of {totalLimit} mL</b>
                </h4>
            </div>
        </div>
    );
}
export default DonationProgress